export const TestimonialSortEnum = Object.freeze({
    date: "date",
});
